// Operator details shown in the Terms of Service and Privacy Policy.
// Update lastUpdated whenever either document changes.
export const LEGAL = {
    companyName: 'Erbol Nurekov',
    serviceName: 'Soulify',
    website: 'soulify.chat',
    contactEmail: 'support@soulify.chat',
    // Read as "governed by the laws of …". Naming a state (e.g. "the State of Delaware, United States") is more precise.
    jurisdiction: 'the United States',
    minimumAge: 18,
    lastUpdated: 'October 23, 2026',
    // Notice before a price change takes effect
    priceChangeNoticeDays: 30,
};

// Bump the version when the disclaimer text changes so users see it again
export const AI_DISCLAIMER_STORAGE_KEY = 'ai_disclaimer_accepted_v1';
